import { UserWorkoutSession } from 'fitbeat.gym-core';
import React, { useState } from 'react';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';
import { HideScrollBarOnWeb } from '../components/HideScrollBarOnWeb';
import Theme from '../theme';
import { isMobile, minDesktopWidth } from '../utils/ScreenSizes';
import { InfluencerHeader } from './InfluencerHeader';
import { InfluencerLearnMorePage } from './InfluencerLearnMore';
import { InfluencerWorkoutTile } from './InfluencerWorkoutTile';

interface IProps {
  influencerBookings: UserWorkoutSession[][];
  influencerName: string;
  influencerId: string;
  avatar: string| null;
  navigation: any;
  workoutTilePressed: (bookingTime: number, inviteId: string) => void;
  clearDeepLinkParamsForInfluencerId(): void;
}

export const InfluencerWithSlotsScreen = ({
  influencerBookings,
  influencerName,
  influencerId,
  avatar,
  navigation,
  workoutTilePressed,
  clearDeepLinkParamsForInfluencerId,
}: IProps) => {
  const [showLearnMore, setShowLearnMore] = useState(false);
  return (
    <HideScrollBarOnWeb className='influencer-container'>
      <View style={styles.container}>
        {showLearnMore && (
          <InfluencerLearnMorePage
            influencerId={influencerId}
            avatar={avatar}
            close={() => {
              setShowLearnMore(false);
            }}
          />
        )}
        {!showLearnMore && (
          <ScrollView style={styles.scrollContainer}>
            <InfluencerHeader
              influencerName={influencerName}
              influencerId={influencerId}
              avatar={avatar}
              navigation={navigation}
              toggleShowLearnMore={()=>setShowLearnMore(true)}
              clearDeepLinkParamsForInfluencerId={clearDeepLinkParamsForInfluencerId}
            />
            {influencerBookings.map((userWorkoutSessions, index) => {
              return (
                <InfluencerWorkoutTile
                  key={index}
                  userWorkoutSessions={userWorkoutSessions}
                  isFirstTile={index === 0}
                  isLastTile={index === influencerBookings.length - 1}
                  workoutTilePressed={workoutTilePressed}
                  navigation={navigation}
                  avatar={avatar}
                />
              );
            })}
          </ScrollView>
        )}
      </View>
    </HideScrollBarOnWeb>
  );
};

const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        width: isMobile() ? '100%' : minDesktopWidth,
      },
    }),
    height: '100%',
  },
  scrollContainer: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },

});
